export default class Alert {
    constructor(container) {
        this.container = container || document.body;
        this.iconClasses = {
            danger: 'icon-warning',
            warning: 'icon-attention-circle',
            success: 'icon-checkmark-circle',
            info: 'icon-info-inversed'
        };
    }

    /**
     * Inserts an alert of a specified type into the DOM after the this.container element.
     *
     * @param {string} alertTitle - The title of the alert.
     * @param {string} alertDescription - The description of the alert.
     * @param {string} type - The type of the alert. It can be 'danger', 'warning', 'success', or 'info'. Defaults to 'danger' if not specified.
     * @param {string} additionalClasses - Additional CSS classes to add to the alert element. Defaults to empty string.
     */
    show(alertTitle, alertDescription, type = 'danger', additionalClasses = '') {
        const iconClass = this.iconClasses[type] || 'icon-warning';
        const iconHMTL =
            type === 'idea'
                ? ''
                : `
            <div class="alert-icon">
                <i class="icon ${iconClass}"></i>
            </div>
        `;
        const alertHTML = `
            <vz-alert class="alert alert-bordered-${type} bg-white d-flex mb-0 ${additionalClasses}">
                <div class="alert-body">
                    ${iconHMTL}
                    <div class="alert-inner">
                        <p class="alert-heading h6">
                            ${alertTitle}
                        </p>
                        <p>
                            ${alertDescription}
                        </p>
                    </div>
                </div>
            </vz-alert>
        `;

        this.container.insertAdjacentHTML('afterend', alertHTML);
    }
}
